export enum PaymentForm {
    IN_ADVANCE = 'in advance',
    IN_ARREARS = 'in arrears',
    MID_OF_THE_PERIOD = 'mid of the period'
}
